/**
 * tokens.ts — canonical TypeScript mirror of src/styles/cpg-tokens.css.
 *
 * Consumed by the MUI theme (cpgTheme.ts), sx props, v4 JSS `styles.ts` edits, and
 * the Stripe Payment Element Appearance API (components/JobPayment/appearance.ts).
 * Values are the light-theme subset of the cpgjobs Next.js tokens (VERBATIM) plus
 * the handoff-only additions.
 *
 * Keep in sync with cpg-tokens.css.
 */

export const TOKENS = {
  // ---- Surfaces / ink ----
  bg: '#ffffff',
  bg2: '#f4f6f9',
  surface: '#ffffff',
  ink: '#0f172a',
  ink2: '#1f2937',
  ink3: '#5b6573',
  line: '#0f172a',
  lineSoft: '#e2e5ea',
  lineDivider: '#cbd5e1',

  // ---- Accent ramp (electric blue) ----
  accent: '#2a90ff',
  accentDeep: '#1873d9',
  accentText: '#1462bf',
  accentSoft: '#e7f0ff',

  // ---- Status / decorative ----
  alert: '#f5a623',
  dot: '#c9d1dc',
  chipBg: '#0f172a',
  chipFg: '#ffffff',

  // ---- Shadow scale ----
  shadowSm: '0 1px 0 rgba(15, 23, 42, 0.06)',
  shadowMd: '0 2px 6px rgba(15, 23, 42, 0.35)',
  shadowBrut: '6px 6px 0 var(--accent-soft)',
  shadow: '0 1px 0 rgba(15, 23, 42, 0.06)',

  // ---- Error / danger (form validation) ----
  danger: '#b42318',
  dangerBg: '#fef3f2',
  dangerBorder: '#fda29b',

  // ---- Handoff-only additions (not in cpgjobs tokens) ----
  go: '#1f9d55',
  goDeep: '#178045',
  goSoft: '#e6f5ec',
  alertDeep: '#cf870c',
  alertSoft: '#fdf0db',
  placeholder: '#9aa3b2',

  // ---- Type families (no next/font indirection) ----
  fontDisplay: "'Poppins', system-ui, sans-serif",
  fontSans: "'Inter', system-ui, sans-serif",
  fontMono: "'JetBrains Mono', ui-monospace, monospace",
} as const;

export type Tokens = typeof TOKENS;

export default TOKENS;
